import React from 'react'
import type { SVGProps } from 'react'
import { colors } from '@mobi/component-library/Theme/Common'
export const LockIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      opacity='0.12'
      d='M5.33398 21.0667C5.33398 18.8265 5.33398 17.7064 5.76996 16.8508C6.15345 16.0981 6.76537 15.4862 7.51802 15.1027C8.37367 14.6667 9.49377 14.6667 11.734 14.6667H20.2673C22.5075 14.6667 23.6276 14.6667 24.4833 15.1027C25.2359 15.4862 25.8479 16.0981 26.2313 16.8508C26.6673 17.7064 26.6673 18.8265 26.6673 21.0667V21.6001C26.6673 23.8403 26.6673 24.9604 26.2313 25.816C25.8479 26.5687 25.2359 27.1806 24.4833 27.5641C23.6276 28.0001 22.5075 28.0001 20.2673 28.0001H11.734C9.49377 28.0001 8.37367 28.0001 7.51802 27.5641C6.76537 27.1806 6.15345 26.5687 5.76996 25.816C5.33398 24.9604 5.33398 23.8403 5.33398 21.6001V21.0667Z'
      fill={colors.warning[700]}
    />
    <path
      d='M22.6673 14.6667V10.6667C22.6673 6.98477 19.6825 4 16.0007 4C12.3188 4 9.33398 6.98477 9.33398 10.6667V14.6667M11.734 28H20.2673C22.5075 28 23.6276 28 24.4833 27.564C25.2359 27.1805 25.8479 26.5686 26.2313 25.816C26.6673 24.9603 26.6673 23.8402 26.6673 21.6V21.0667C26.6673 18.8265 26.6673 17.7064 26.2313 16.8507C25.8479 16.0981 25.2359 15.4861 24.4833 15.1026C23.6276 14.6667 22.5075 14.6667 20.2673 14.6667H11.734C9.49377 14.6667 8.37367 14.6667 7.51802 15.1026C6.76537 15.4861 6.15345 16.0981 5.76996 16.8507C5.33398 17.7064 5.33398 18.8265 5.33398 21.0667V21.6C5.33398 23.8402 5.33398 24.9603 5.76996 25.816C6.15345 26.5686 6.76537 27.1805 7.51802 27.564C8.37367 28 9.49377 28 11.734 28Z'
      stroke={colors.warning[700]}
      strokeWidth='2.66667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
